<template>
	<div class="shop-container u-container">
		<form @submit.prevent="search" class="py-4">
			<div class="columns">
				<div class="column col-4">
					<select ref="shopArea" class="form-select">
						<option value="">지역 선택</option>
						<option
							v-for="item in branchAreaList"
							:value="item.category_name"
							:key="item.uid"
						>
							{{ item.category_name }}
						</option>
					</select>
				</div>
				<div class="column">
					<input
						ref="shopName"
						class="form-input"
						type="text"
						placeholder="지점명"
					/>
				</div>
				<div class="column col-auto">
					<BaseBtn color="primary" type="submit" medium block>검색</BaseBtn>
				</div>
				<div v-if="isResetSorting" class="column col-12 mt-2">
					<BaseBtn
						@click="resetSorting"
						color="secondary"
						type="button"
						medium
						block
						>검색 초기화</BaseBtn
					>
				</div>
			</div>
		</form>

		<ul v-if="shopList" class="shop-list">
			<li class="shop-list__item" v-for="item in shopList" :key="item.ar_id">
				<ShopItem :item="item"></ShopItem>
			</li>
		</ul>

		<!-- 지점 상세 다이어로그 -->
		<BaseDialog
			:options="shopDetailOptions"
			@okCallback="callbackReservationApp"
		>
			<template v-slot:message>
				<ShopDetailTable :item="shopItem"></ShopDetailTable>
				<div class="map-container">
					<KakaoMap
						:address="shopItem.ar_addr1"
						:coord="shopMapCoord"
						isMarker
					></KakaoMap>
				</div>
			</template>
		</BaseDialog>

		<InfiniteLoading
			ref="infiniteLoading"
			@infinite="infinite"
		></InfiniteLoading>
	</div>
</template>

<script>
import BaseBtn from '@/components/common/Btn';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import KakaoMap from '@/components/common/KakaoMap';
import BaseDialog from '@/components/common/BaseDialog';

import ShopItem from './item';
import ShopDetailTable from './ShopDetailTable';
export default {
	components: {
		BaseBtn,
		InfiniteLoading,
		KakaoMap,
		BaseDialog,
		ShopItem,
		ShopDetailTable,
	},
	data() {
		return {
			page: 1,
			shopArea: '',
			shopName: '',
		};
	},
	computed: {
		isResetSorting() {
			return this.shopArea || this.shopName;
		},
		branchAreaList() {
			return this.$store.getters['appStore/branchAreaList'];
		},
		shopList() {
			return this.$store.getters['shopStore/shopList'];
		},
		shopItem() {
			return this.$store.getters['shopStore/shopDetail'];
		},
		shopMapCoord() {
			return this.shopItem.shop_map
				? [
						parseFloat(this.shopItem.shop_map.split(',')[0]),
						parseFloat(this.shopItem.shop_map.split(',')[1]),
				  ]
				: [0, 0];
		},
		shopDetailOptions() {
			return {
				title: this.shopItem.shop_name,
				size: 'large',
				okLabel: '예약 신청',
			};
		},
		shopDetailBranch() {
			return this.$store.getters['shopStore/shopDetailBranch'];
		},
	},
	methods: {
		async fetchBranchAreaList() {
			return await this.$store.dispatch('appStore/getBranchAreaList');
		},
		async fetchShopList() {
			const payload = {
				page: this.page,
				shopArea: this.shopArea,
				shopName: this.shopName,
			};
			return await this.$store.dispatch('shopStore/getShopList', payload);
		},
		infinite(state) {
			this.fetchShopList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;

					/**
					 * 데이터 가져오는 속도가 빨라서
					 * 스크롤시 무한 스크롤링 로딩 아이콘 노출 시간이 짧아서 보이지 않음.
					 * 임의로 가져오는 속도 늦춤.
					 */
					setTimeout(() => state.loaded(), 400);
				}
			});
		},
		search() {
			this.shopArea = this.$refs.shopArea.value;
			this.shopName = this.$refs.shopName.value;

			this.initRender();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
		initRender() {
			this.page = 1;
			this.$store.dispatch('shopStore/initShopList');
		},
		resetSorting() {
			this.$refs.shopArea.value = '';
			this.$refs.shopName.value = '';
			this.search();
		},
		async callbackReservationApp() {
			const payload = {
				arId: this.shopItem.ar_id,
			};
			await this.$store.dispatch('shopStore/getShopDetailBranch', payload);

			this.$router.push({
				name: 'reservationApp',
				params: { branchName: this.shopDetailBranch.mini_company },
			});
		},
	},
	created() {
		// 지점 지역 목록 가져오기
		this.fetchBranchAreaList();
	},
};
</script>

<style scoped>
.shop-container {
	padding-bottom: 1.875rem;
}

.shop-list {
	display: flex;
	flex-flow: row wrap;
	margin: -0.5rem;
	padding: 0.5rem 0;
}

.shop-list__item {
	width: 50%;
	padding: 0.5rem;
}

.map-container {
	margin-top: 1rem;
}
</style>
